module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-money-e4c5ca93e3732127d0d983609db8c750.png";